/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SOCKET = project.getFeature(feature.getSettingValue('SOCKET'));
    if (!SOCKET) {
        return blocks;
    }
    const NAME = SOCKET.getSettingValue('NAME');
    const functionName = `${NAME}_data_available`;
    let dataLocation = '';

    const links = project.getNodeLinks(feature, 'sock_data_arrival');
    if (links.length > 0) {
        const link = links[0];
        dataLocation += `'****${link.getSourceId()}****'\r\n`;
    }

    blocks.push({
        location: 'on_sock_data_arrival',
        id: `${NAME}_data_arrival`,
        blockType: BlockType.CODE,
        template: `
if sock.num=${NAME}_SOCK_NUM then
    dim ${NAME}_data as string=sock.getdata(255)
    ${functionName}(${NAME}_data)
end if
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        id: functionName,
        blockType: BlockType.CODE,
        template: `
sub ${functionName}(data as string)
${dataLocation}
end sub
    `,
    });
    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        id: `declare_${functionName}`,
        blockType: BlockType.CODE,
        template: `
declare sub ${functionName}(data as string)`,
    });


    return blocks;
};
